// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  Redirect,
  Route,
  RouteProps,
  BrowserRouter as Router,
  Switch,
  useHistory
} from 'react-router-dom';
import { transitions, positions, AlertProviderProps, Provider as AlertProvider, AlertManager } from 'react-alert'
import { useSelector } from 'react-redux';

import MemberContext, { MemberContextProvider } from './contexts/MemberContext';
import ConfirmEmailPage from './pages/ConfirmEmailPage/ConfirmEmailPage';
import ForgetPasswordPage from './pages/ForgetPasswordPage/ForgetPasswordPage';
import GotoEmailPage from './pages/GotoEmailPage/GotoEmailPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage/LoginPage';
import MemberPage from './pages/MemberPage';
import SupportPage from './pages/SupportPage';
import OnlineCoursePage from './pages/OnlineCoursePage/OnlineCoursePage';
import OnlineCourseContentPage from './pages/OnlineCourseContentPage';
import OnlineCourseListPage from './pages/OnlineCourseListPage';
import IltCoursePage from './pages/IltCoursePage/IltCoursePage';
import IltCourseContentPage from './pages/IltCourseContentPage';
import OrdersPage from './pages/OrdersPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import LabPage from './pages/LabPage';
import ChallengeListPage from './pages/ChallengeListPage';
import ChallengePage from './pages/ChallengePage';
import LabListPage from './pages/LabListPage';
import LandingPage from './pages/LandingPage';
import ExamListPage from './pages/ExamListPage';
import ExamPage from './pages/ExamPage';
import FaqPage from './pages/FaqPage';
import ExamReviewPage from './pages/ExamReviewPage';
import { WebSocketContextProvider } from './contexts/WebSocketContext';
import { postJoinOrganization } from './apis/member';
import WorkshopPage from './pages/WorkshopPage/WorkshopPage';
import WorkshopContentPage from './pages/WorkshopContentPage';
import { makeFooterVisibleHeight } from './redux/selectors/mainLayoutSelector/mainLayoutSelector';
import VideoSnackbar from './components/CourseContent/components/VideoSnackbar';
import Snackbar from './components/Snackbar';
import { CommonContextProvider } from './contexts/CommonContext';
import RedirectBifrost from './pages/LoginPage/RedirectBifrost';

function AuthRoute(props: RouteProps) {
  const history = useHistory();
  const member = useContext(MemberContext);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (member.isLogin) {
      const invitation = localStorage.getItem('invitation');
      if (invitation) {
        postJoinOrganization(invitation);
        localStorage.removeItem('invitation');
      }
      setValid(true);
    } else {
      history.push('/login')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member.isLogin]);

  if (valid) {
    return <Route {...props} />;
  }

  return null;
}

export const VideoSnackbarContext = createContext<AlertManager|undefined>(undefined)

export default function MyRouter(): JSX.Element {
  const footerVisibleHeight = useSelector(makeFooterVisibleHeight());

  const alertOptions: AlertProviderProps = useMemo(() => ({
    template: Snackbar,
    position: positions.BOTTOM_LEFT,
    offset: '100px',
    containerStyle: {
      zIndex: 5,
      left: '24px',
      bottom: (24 + footerVisibleHeight) + 'px',
      width: '',
      transition: 'bottom 0.5s ease-in',
      pointerEvents: 'auto',
    },
    transition: transitions.FADE
  }), [footerVisibleHeight])

  const videoAlertOptions: AlertProviderProps = useMemo(() => ({
    template: VideoSnackbar,
    position: positions.BOTTOM_LEFT,
    offset: '100px',
    containerStyle: {
      zIndex: 5,
      left: '24px',
      bottom: (24 + footerVisibleHeight) + 'px',
      width: '',
      transition: 'bottom 0.5s ease-in',
      pointerEvents: 'auto',
    },
    timeout: 5000,
    transition: transitions.FADE,
    context: VideoSnackbarContext
  }), [footerVisibleHeight])

  return (
    <MemberContextProvider>
      <WebSocketContextProvider>
        <CommonContextProvider>
          <Router>
            <AlertProvider {...alertOptions}>
              <AlertProvider {...videoAlertOptions}>
                <Switch>
                  <Route exact path="/login/redirect/:id" component={RedirectBifrost} />
                  <Route exact path="/login" component={LoginPage} />
                  <Route exact path="/register" component={RegisterPage} />
                  <Route exact path="/confirmEmail" component={ConfirmEmailPage} />
                  <Route exact path="/gotoEmail" component={GotoEmailPage} />
                  <Route
                    exact
                    path="/forgotPassword"
                    component={ForgetPasswordPage}
                  />
                  <Route exact path="/resetPassword" component={ResetPasswordPage} />
                  <Route exact path="/" component={LandingPage} />
                  <Route exact path="/examReview/:token" component={ExamReviewPage} />
                  {/* Need Login */}
                  <AuthRoute exact path="/home" component={HomePage} />
                  <AuthRoute exact path="/onlineCourses" component={OnlineCourseListPage} />
                  <AuthRoute exact path="/labs" component={LabListPage} />
                  <AuthRoute exact path="/onlineCourses/:id/contents" component={OnlineCourseContentPage} />
                  <AuthRoute exact path="/labs/:id" component={LabPage} />
                  {/* TODO En Modify */}
                  <AuthRoute exact path="/challenges" component={ChallengeListPage} />
                  <AuthRoute exact path="/challenges/:id" component={ChallengePage} />
                  <AuthRoute exact path="/exams" component={ExamListPage} />
                  <AuthRoute exact path="/exams/:id" component={ExamPage} />
                  <AuthRoute
                    exact
                    path="/onlineCourses/:id"
                    component={OnlineCoursePage}
                  />
                  <AuthRoute
                    exact
                    path="/workshops/:id"
                    component={WorkshopPage}
                  />
                  <AuthRoute exact path="/workshops/:id/contents" component={WorkshopContentPage} />
                  <AuthRoute
                    exact
                    path="/iltCourses/:id"
                    component={IltCoursePage}
                  />
                  <AuthRoute exact path="/iltCourses/:id/contents" component={IltCourseContentPage} />
                  <AuthRoute exact path="/member" component={MemberPage} />
                  <AuthRoute exact path="/orders" component={OrdersPage} />
                  <AuthRoute exact path="/support" component={SupportPage} />
                  <AuthRoute exact path="/faq" component={FaqPage} />
                  {/* Disable privacy and terms page until content is ready */}
                  {/* <Route exact path="/privacy" component={PrivacyPage} /> */}
                  {/* <Route exact path="/terms" component={TermsPage} /> */}
                  <Redirect to={{ pathname: '/' }} />
                </Switch>
              </AlertProvider>
            </AlertProvider>
          </Router>
        </CommonContextProvider>
      </WebSocketContextProvider>
    </MemberContextProvider>
  );
}
